import React from 'react';

import { ErrorDisplay } from '../ErrorDisplay';

export default class ElementErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorDisplay message={'An unexpected UI error has occured!'} />;
    } else {
      return this.props.children;
    }
  }
}
